import { CheckoutHeader } from '../components/Checkout/CheckoutHeader';
import React from "react";


interface CheckoutLayoutProps {
  children: React.ReactNode;
}

const CheckoutLayout: React.FC<CheckoutLayoutProps> = ({ children }) => {

  return (
    <>
      <CheckoutHeader />
      <main>
        {children}
      </main>
    </>
  );
};

export default CheckoutLayout;














